var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "endorse-block" },
    [
      _c(
        "button",
        {
          staticClass: "btn endorse-block__button btn--secondary",
          class: {
            "btn--disabled": _vm.endorsement.sent
          },
          attrs: { type: "button", disabled: _vm.endorsement.sent },
          on: { click: _vm.openModal }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                width: "25pt",
                height: "25pt",
                viewBox: "0 0 25 25",
                version: "1.1"
              }
            },
            [
              _c("g", { attrs: { id: "surface1" } }, [
                _c("path", {
                  staticStyle: {
                    stroke: "none",
                    "fill-rule": "nonzero",
                    fill: "rgb(100%,100%,100%)",
                    "fill-opacity": "1"
                  },
                  style: {
                    "btn--orange": _vm.endorsement.sent,
                    "btn--secondary": !_vm.endorsement.sent
                  },
                  attrs: {
                    d:
                      "M 4.429688 18.601562 C 4.429688 18.359375 4.339844 18.152344 4.164062 17.980469 C 3.992188 17.804688 3.78125 17.714844 3.542969 17.714844 C 3.292969 17.714844 3.085938 17.804688 2.914062 17.980469 C 2.742188 18.152344 2.65625 18.359375 2.65625 18.601562 C 2.65625 18.851562 2.742188 19.058594 2.914062 19.230469 C 3.085938 19.402344 3.292969 19.488281 3.542969 19.488281 C 3.78125 19.488281 3.992188 19.402344 4.164062 19.230469 C 4.339844 19.058594 4.429688 18.851562 4.429688 18.601562 Z M 6.644531 11.515625 L 6.644531 20.371094 C 6.644531 20.613281 6.554688 20.820312 6.378906 20.996094 C 6.203125 21.171875 5.996094 21.257812 5.757812 21.257812 L 1.769531 21.257812 C 1.53125 21.257812 1.324219 21.171875 1.148438 20.996094 C 0.972656 20.820312 0.886719 20.613281 0.886719 20.371094 L 0.886719 11.515625 C 0.886719 11.273438 0.972656 11.066406 1.148438 10.890625 C 1.324219 10.71875 1.53125 10.628906 1.769531 10.628906 L 5.757812 10.628906 C 5.996094 10.628906 6.203125 10.71875 6.378906 10.890625 C 6.554688 11.066406 6.644531 11.273438 6.644531 11.515625 Z M 23.03125 11.515625 C 23.03125 12.308594 22.777344 12.996094 22.269531 13.578125 C 22.40625 13.984375 22.476562 14.335938 22.476562 14.628906 C 22.503906 15.332031 22.304688 15.960938 21.882812 16.527344 C 22.039062 17.042969 22.039062 17.582031 21.882812 18.144531 C 21.742188 18.671875 21.492188 19.105469 21.132812 19.445312 C 21.21875 20.480469 20.992188 21.3125 20.457031 21.953125 C 19.863281 22.652344 18.957031 23.011719 17.730469 23.03125 L 15.945312 23.03125 C 15.335938 23.03125 14.667969 22.957031 13.949219 22.816406 C 13.230469 22.671875 12.671875 22.539062 12.269531 22.414062 C 11.867188 22.289062 11.3125 22.109375 10.601562 21.867188 C 9.46875 21.472656 8.738281 21.265625 8.414062 21.257812 C 8.175781 21.25 7.96875 21.160156 7.792969 20.988281 C 7.617188 20.816406 7.53125 20.613281 7.53125 20.371094 L 7.53125 11.5 C 7.53125 11.269531 7.613281 11.070312 7.777344 10.898438 C 7.945312 10.730469 8.140625 10.632812 8.371094 10.617188 C 8.59375 10.597656 8.945312 10.324219 9.425781 9.796875 C 9.90625 9.273438 10.371094 8.714844 10.824219 8.125 C 11.453125 7.324219 11.917969 6.769531 12.21875 6.464844 C 12.386719 6.296875 12.53125 6.078125 12.652344 5.800781 C 12.769531 5.523438 12.851562 5.300781 12.894531 5.128906 C 12.933594 4.957031 12.996094 4.675781 13.078125 4.289062 C 13.144531 3.929688 13.199219 3.648438 13.25 3.445312 C 13.300781 3.242188 13.394531 3.003906 13.523438 2.726562 C 13.652344 2.449219 13.808594 2.21875 13.992188 2.035156 C 14.167969 1.859375 14.375 1.769531 14.617188 1.769531 C 15.039062 1.769531 15.417969 1.820312 15.757812 1.917969 C 16.09375 2.011719 16.371094 2.132812 16.589844 2.277344 C 16.804688 2.421875 16.988281 2.605469 17.140625 2.835938 C 17.292969 3.066406 17.402344 3.273438 17.472656 3.460938 C 17.542969 3.644531 17.597656 3.875 17.640625 4.152344 C 17.679688 4.429688 17.703125 4.636719 17.707031 4.773438 C 17.714844 4.914062 17.714844 5.09375 17.714844 5.316406 C 17.714844 5.664062 17.671875 6.015625 17.582031 6.367188 C 17.496094 6.71875 17.410156 6.996094 17.320312 7.195312 C 17.234375 7.398438 17.105469 7.65625 16.941406 7.972656 C 16.914062 8.027344 16.867188 8.109375 16.800781 8.222656 C 16.738281 8.332031 16.6875 8.433594 16.648438 8.527344 C 16.613281 8.617188 16.578125 8.730469 16.539062 8.855469 L 20.371094 8.855469 C 21.09375 8.855469 21.714844 9.121094 22.242188 9.648438 C 22.765625 10.171875 23.03125 10.792969 23.03125 11.515625 Z M 23.03125 11.515625 "
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  staticStyle: {
                    stroke: "none",
                    "fill-rule": "nonzero",
                    fill: "rgb(100%,100%,100%)",
                    "fill-opacity": "1"
                  },
                  attrs: {
                    d:
                      "M 2.1875 16.855469 L 4.746094 16.855469 L 4.746094 19.625 L 2.1875 19.625 Z M 2.1875 16.855469 "
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Endorse this")])
        ]
      ),
      _vm._v(" "),
      _vm.endorsements.length > 0
        ? [
            _c("div", { staticClass: "endorse-block__counter" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.endorsementsCount) + " endorsments")
              ]),
              _vm._v(", including\n        ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "endorse-block__list" },
              _vm._l(_vm.endorsements, function(person, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "endorse-block__item" },
                  [
                    _c("div", { staticClass: "endorse-block__item-name" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(person.name) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "endorse-block__item-pos" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(person.from) +
                          "\n                "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.is_modal_open,
              expression: "is_modal_open"
            }
          ],
          on: { close: _vm.closeModal }
        },
        [
          _c(
            "div",
            {
              staticClass: "endorse-modal",
              class: {
                "endorse-modal--success": _vm.endorsement_verified
              },
              attrs: { id: "endorse-modal" }
            },
            [
              _c(
                "button",
                {
                  staticClass: "endorse-modal__close",
                  attrs: { type: "button" },
                  on: { click: _vm.closeModal }
                },
                [_c("span"), _vm._v(" "), _c("span")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "endorse-modal__icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "25pt",
                      height: "25pt",
                      viewBox: "0 0 25 25",
                      version: "1.1"
                    }
                  },
                  [
                    _c("g", { attrs: { id: "surface1" } }, [
                      _c("path", {
                        staticStyle: {
                          stroke: "none",
                          "fill-rule": "nonzero",
                          fill: "rgb(100%, 100%, 100%)",
                          "fill-opacity": "1"
                        },
                        attrs: {
                          d:
                            "M 4.429688 18.601562 C 4.429688 18.359375 4.339844 18.152344 4.164062 17.980469 C 3.992188 17.804688 3.78125 17.714844 3.542969 17.714844 C 3.292969 17.714844 3.085938 17.804688 2.914062 17.980469 C 2.742188 18.152344 2.65625 18.359375 2.65625 18.601562 C 2.65625 18.851562 2.742188 19.058594 2.914062 19.230469 C 3.085938 19.402344 3.292969 19.488281 3.542969 19.488281 C 3.78125 19.488281 3.992188 19.402344 4.164062 19.230469 C 4.339844 19.058594 4.429688 18.851562 4.429688 18.601562 Z M 6.644531 11.515625 L 6.644531 20.371094 C 6.644531 20.613281 6.554688 20.820312 6.378906 20.996094 C 6.203125 21.171875 5.996094 21.257812 5.757812 21.257812 L 1.769531 21.257812 C 1.53125 21.257812 1.324219 21.171875 1.148438 20.996094 C 0.972656 20.820312 0.886719 20.613281 0.886719 20.371094 L 0.886719 11.515625 C 0.886719 11.273438 0.972656 11.066406 1.148438 10.890625 C 1.324219 10.71875 1.53125 10.628906 1.769531 10.628906 L 5.757812 10.628906 C 5.996094 10.628906 6.203125 10.71875 6.378906 10.890625 C 6.554688 11.066406 6.644531 11.273438 6.644531 11.515625 Z M 23.03125 11.515625 C 23.03125 12.308594 22.777344 12.996094 22.269531 13.578125 C 22.40625 13.984375 22.476562 14.335938 22.476562 14.628906 C 22.503906 15.332031 22.304688 15.960938 21.882812 16.527344 C 22.039062 17.042969 22.039062 17.582031 21.882812 18.144531 C 21.742188 18.671875 21.492188 19.105469 21.132812 19.445312 C 21.21875 20.480469 20.992188 21.3125 20.457031 21.953125 C 19.863281 22.652344 18.957031 23.011719 17.730469 23.03125 L 15.945312 23.03125 C 15.335938 23.03125 14.667969 22.957031 13.949219 22.816406 C 13.230469 22.671875 12.671875 22.539062 12.269531 22.414062 C 11.867188 22.289062 11.3125 22.109375 10.601562 21.867188 C 9.46875 21.472656 8.738281 21.265625 8.414062 21.257812 C 8.175781 21.25 7.96875 21.160156 7.792969 20.988281 C 7.617188 20.816406 7.53125 20.613281 7.53125 20.371094 L 7.53125 11.5 C 7.53125 11.269531 7.613281 11.070312 7.777344 10.898438 C 7.945312 10.730469 8.140625 10.632812 8.371094 10.617188 C 8.59375 10.597656 8.945312 10.324219 9.425781 9.796875 C 9.90625 9.273438 10.371094 8.714844 10.824219 8.125 C 11.453125 7.324219 11.917969 6.769531 12.21875 6.464844 C 12.386719 6.296875 12.53125 6.078125 12.652344 5.800781 C 12.769531 5.523438 12.851562 5.300781 12.894531 5.128906 C 12.933594 4.957031 12.996094 4.675781 13.078125 4.289062 C 13.144531 3.929688 13.199219 3.648438 13.25 3.445312 C 13.300781 3.242188 13.394531 3.003906 13.523438 2.726562 C 13.652344 2.449219 13.808594 2.21875 13.992188 2.035156 C 14.167969 1.859375 14.375 1.769531 14.617188 1.769531 C 15.039062 1.769531 15.417969 1.820312 15.757812 1.917969 C 16.09375 2.011719 16.371094 2.132812 16.589844 2.277344 C 16.804688 2.421875 16.988281 2.605469 17.140625 2.835938 C 17.292969 3.066406 17.402344 3.273438 17.472656 3.460938 C 17.542969 3.644531 17.597656 3.875 17.640625 4.152344 C 17.679688 4.429688 17.703125 4.636719 17.707031 4.773438 C 17.714844 4.914062 17.714844 5.09375 17.714844 5.316406 C 17.714844 5.664062 17.671875 6.015625 17.582031 6.367188 C 17.496094 6.71875 17.410156 6.996094 17.320312 7.195312 C 17.234375 7.398438 17.105469 7.65625 16.941406 7.972656 C 16.914062 8.027344 16.867188 8.109375 16.800781 8.222656 C 16.738281 8.332031 16.6875 8.433594 16.648438 8.527344 C 16.613281 8.617188 16.578125 8.730469 16.539062 8.855469 L 20.371094 8.855469 C 21.09375 8.855469 21.714844 9.121094 22.242188 9.648438 C 22.765625 10.171875 23.03125 10.792969 23.03125 11.515625 Z M 23.03125 11.515625 "
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticStyle: {
                          stroke: "none",
                          "fill-rule": "nonzero",
                          fill: "rgb(100%,100%,100%)",
                          "fill-opacity": "1"
                        },
                        attrs: {
                          d:
                            "M 2.1875 16.855469 L 4.746094 16.855469 L 4.746094 19.625 L 2.1875 19.625 Z M 2.1875 16.855469 "
                        }
                      })
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "endorse-modal__tell" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.endorsement_verified
                        ? "Success!"
                        : "Endorse this proposal"
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              !_vm.endorsement.sent && !_vm.endorsement_verified
                ? [
                    _c(
                      "form",
                      {
                        staticClass: "endorse-modal__form",
                        attrs: { action: "" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.endorsement.name,
                              expression: "endorsement.name"
                            }
                          ],
                          staticClass: "endorse-modal__input",
                          attrs: { type: "text", placeholder: "My name is" },
                          domProps: { value: _vm.endorsement.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.endorsement,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.endorsement.from,
                              expression: "endorsement.from"
                            }
                          ],
                          staticClass: "endorse-modal__input",
                          attrs: { type: "text", placeholder: "and I am from" },
                          domProps: { value: _vm.endorsement.from },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.endorsement,
                                "from",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.endorsement.email,
                              expression: "endorsement.email"
                            }
                          ],
                          staticClass: "endorse-modal__input",
                          attrs: {
                            type: "email",
                            placeholder: "and my email is"
                          },
                          domProps: { value: _vm.endorsement.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.endorsement,
                                "email",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "endorse-modal__submit",
                          class: {
                            disabled: !_vm.isEnabled
                          },
                          attrs: { type: "submit" },
                          domProps: { value: _vm.endorseString },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.endorse($event)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "endorse-modal__counter" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.endorsementsCount) +
                          " endorsed this\n                "
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.endorsement.sent && !_vm.endorsement_verified
                ? [
                    _c(
                      "div",
                      { staticClass: "endorse-modal__submitted-message" },
                      [
                        _vm._v(
                          '\n                    Please click the "verify" link in your email to confirm your endorsement!\n                '
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.endorsement_verified
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "endorse-modal__submitted-message endorse-modal__submitted-message--verify"
                      },
                      [
                        _vm._v(
                          "\n                    Thanks for your endorsement!\n                "
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slideUp-thanks" } }, [
                _vm.endorsement.sent && !_vm.endorsement_verified
                  ? _c(
                      "div",
                      { staticClass: "endorse-modal__submitted-actions" },
                      [
                        _c(
                          "div",
                          { staticClass: "endorse-modal__submitted-thanks" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "endorse-modal__submitted-thanks-icon"
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      width: "25pt",
                                      height: "25pt",
                                      viewBox: "0 0 25 25",
                                      version: "1.1"
                                    }
                                  },
                                  [
                                    _c("g", { attrs: { id: "surface1" } }, [
                                      _c("path", {
                                        staticStyle: {
                                          stroke: "none",
                                          "fill-rule": "nonzero",
                                          fill: "rgb(100%,100%,100%)",
                                          "fill-opacity": "1"
                                        },
                                        attrs: {
                                          d:
                                            "M 4.429688 18.601562 C 4.429688 18.359375 4.339844 18.152344 4.164062 17.980469 C 3.992188 17.804688 3.78125 17.714844 3.542969 17.714844 C 3.292969 17.714844 3.085938 17.804688 2.914062 17.980469 C 2.742188 18.152344 2.65625 18.359375 2.65625 18.601562 C 2.65625 18.851562 2.742188 19.058594 2.914062 19.230469 C 3.085938 19.402344 3.292969 19.488281 3.542969 19.488281 C 3.78125 19.488281 3.992188 19.402344 4.164062 19.230469 C 4.339844 19.058594 4.429688 18.851562 4.429688 18.601562 Z M 6.644531 11.515625 L 6.644531 20.371094 C 6.644531 20.613281 6.554688 20.820312 6.378906 20.996094 C 6.203125 21.171875 5.996094 21.257812 5.757812 21.257812 L 1.769531 21.257812 C 1.53125 21.257812 1.324219 21.171875 1.148438 20.996094 C 0.972656 20.820312 0.886719 20.613281 0.886719 20.371094 L 0.886719 11.515625 C 0.886719 11.273438 0.972656 11.066406 1.148438 10.890625 C 1.324219 10.71875 1.53125 10.628906 1.769531 10.628906 L 5.757812 10.628906 C 5.996094 10.628906 6.203125 10.71875 6.378906 10.890625 C 6.554688 11.066406 6.644531 11.273438 6.644531 11.515625 Z M 23.03125 11.515625 C 23.03125 12.308594 22.777344 12.996094 22.269531 13.578125 C 22.40625 13.984375 22.476562 14.335938 22.476562 14.628906 C 22.503906 15.332031 22.304688 15.960938 21.882812 16.527344 C 22.039062 17.042969 22.039062 17.582031 21.882812 18.144531 C 21.742188 18.671875 21.492188 19.105469 21.132812 19.445312 C 21.21875 20.480469 20.992188 21.3125 20.457031 21.953125 C 19.863281 22.652344 18.957031 23.011719 17.730469 23.03125 L 15.945312 23.03125 C 15.335938 23.03125 14.667969 22.957031 13.949219 22.816406 C 13.230469 22.671875 12.671875 22.539062 12.269531 22.414062 C 11.867188 22.289062 11.3125 22.109375 10.601562 21.867188 C 9.46875 21.472656 8.738281 21.265625 8.414062 21.257812 C 8.175781 21.25 7.96875 21.160156 7.792969 20.988281 C 7.617188 20.816406 7.53125 20.613281 7.53125 20.371094 L 7.53125 11.5 C 7.53125 11.269531 7.613281 11.070312 7.777344 10.898438 C 7.945312 10.730469 8.140625 10.632812 8.371094 10.617188 C 8.59375 10.597656 8.945312 10.324219 9.425781 9.796875 C 9.90625 9.273438 10.371094 8.714844 10.824219 8.125 C 11.453125 7.324219 11.917969 6.769531 12.21875 6.464844 C 12.386719 6.296875 12.53125 6.078125 12.652344 5.800781 C 12.769531 5.523438 12.851562 5.300781 12.894531 5.128906 C 12.933594 4.957031 12.996094 4.675781 13.078125 4.289062 C 13.144531 3.929688 13.199219 3.648438 13.25 3.445312 C 13.300781 3.242188 13.394531 3.003906 13.523438 2.726562 C 13.652344 2.449219 13.808594 2.21875 13.992188 2.035156 C 14.167969 1.859375 14.375 1.769531 14.617188 1.769531 C 15.039062 1.769531 15.417969 1.820312 15.757812 1.917969 C 16.09375 2.011719 16.371094 2.132812 16.589844 2.277344 C 16.804688 2.421875 16.988281 2.605469 17.140625 2.835938 C 17.292969 3.066406 17.402344 3.273438 17.472656 3.460938 C 17.542969 3.644531 17.597656 3.875 17.640625 4.152344 C 17.679688 4.429688 17.703125 4.636719 17.707031 4.773438 C 17.714844 4.914062 17.714844 5.09375 17.714844 5.316406 C 17.714844 5.664062 17.671875 6.015625 17.582031 6.367188 C 17.496094 6.71875 17.410156 6.996094 17.320312 7.195312 C 17.234375 7.398438 17.105469 7.65625 16.941406 7.972656 C 16.914062 8.027344 16.867188 8.109375 16.800781 8.222656 C 16.738281 8.332031 16.6875 8.433594 16.648438 8.527344 C 16.613281 8.617188 16.578125 8.730469 16.539062 8.855469 L 20.371094 8.855469 C 21.09375 8.855469 21.714844 9.121094 22.242188 9.648438 C 22.765625 10.171875 23.03125 10.792969 23.03125 11.515625 Z M 23.03125 11.515625 "
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        staticStyle: {
                                          stroke: "none",
                                          "fill-rule": "nonzero",
                                          fill: "rgb(100%,100%,100%)",
                                          "fill-opacity": "1"
                                        },
                                        attrs: {
                                          d:
                                            "M 2.1875 16.855469 L 4.746094 16.855469 L 4.746094 19.625 L 2.1875 19.625 Z M 2.1875 16.855469 "
                                        }
                                      })
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Thanks for endorsing")])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }